import apiClient from './client';

export const importJobsAPI = {
  // Create a new import job. Accepts the same `creators` payload as the
  // existing bulk upload, plus an optional user-provided `name`.
  // Returns { job, results, enrichingInBackground }.
  create: (payload) =>
    apiClient.post('/import-jobs', payload, { timeout: 180000 }),

  // List recent jobs for the current organization with live progress stats.
  list: (params) => apiClient.get('/import-jobs', { params }),

  // Fetch a single job with live-computed progress.
  getOne: (id) => apiClient.get(`/import-jobs/${id}`),

  // Rename a job
  rename: (id, name) => apiClient.patch(`/import-jobs/${id}`, { name }),

  // Delete a job from history (does NOT remove its creators)
  delete: (id) => apiClient.delete(`/import-jobs/${id}`),
};
